import React, {Component} from 'react';
import Chart from "react-google-charts";

//cal rebre a través de props: valor i valorTotal en format numèric

class GraficRodo2Valors extends Component {	
    render() {           
     return (
         <div>
            {this.props.valor!==0&&this.props.valorTotal && ( 
                <Chart
                    width={'100%'}
                    height={'100px'}
                    chartType="PieChart"
                    loader={<div>Carregant gràfic</div>}
                    data={[
                        ['Nom', 'Valor', { role: 'style' }, { role: 'tooltip' },],
                        ['', this.props.valor, 'color: #0D7AF5', ''],
                        ['', (this.props.valorTotal-this.props.valor), 'color: #e5e4e2', '']
                    ]}
                    options={{
                        // Just add this option
                        legend: 'none',
                        pieSliceTextStyle: {
                            color: 'transparent',
                          },
                        backgroundColor: { fill:'transparent' },
                        pieHole: 0.8,
                        slices: {
                            0: { color: '#0D7AF5' },
                            1: { color: '#e5e4e2' },
                        },
                    }}
                    rootProps={{ 'data-testid': '3' }}
                />
            )}

            {this.props.valor==0 && ( 
                <Chart
                    width={'100%'}
                    height={'100px'}
                    chartType="PieChart"
                    loader={<div>Carregant gràfic</div>}
                    data={[
                        ['Nom', 'Valor', { role: 'style' }, { role: 'tooltip' },],
                        ['', 0, 'color: #0D7AF5', ''],
                        ['', 100, 'color: #e5e4e2', '']
                    ]}
                    options={{
                        // Just add this option
                        legend: 'none',
                        pieSliceTextStyle: {
                            color: 'transparent',
                          },
                        backgroundColor: { fill:'transparent' },
                        pieHole: 0.8,
                        slices: {
                            0: { color: '#0D7AF5' },
                            1: { color: '#e5e4e2' },
                        },
                    }}
                    rootProps={{ 'data-testid': '3' }}
                />
            )}
        </div>
      );
    }
  }

  export default GraficRodo2Valors;